import { MouseEventHandler } from 'react';
import customIcons from '../utils/icons';
import Tooltip from './toolTip';
import { ChipProps } from '../types/buttons.type';

export default function Chip({
  closeButton, onClick, text, colour, tooltip, small, hasDot, className = '',
}: Readonly<ChipProps>) {
  const getChipClasses = (chipColour: string, clickable?: MouseEventHandler<HTMLElement>, isSmall?: boolean) => {
    const base: Record<string, string> = {
      green: 'chip-green',
      blue: 'chip-blue',
      red: 'chip-red',
      purple: 'chip-purple',
      yellow: 'chip-yellow',
      pippink: 'chip-pippink',
      pipgreen: 'chip-pipgreen',
      pippurple: 'chip-pippurple',
    };
    const hover: Record<string, string> = {
      green: 'hover:bg-emerald-100',
      blue: 'hover:bg-sky-100',
      red: 'hover:bg-rose-100',
      purple: 'hover:bg-violet-100',
      yellow: 'hover:bg-yellow-100',
    };
    const baseClass = base[chipColour] || 'chip-default';
    const hoverClass = clickable ? (hover[chipColour] || 'hover:bg-gray-200') : '';
    const sizeClass = isSmall ? 'small-chip' : 'chip';
    return [baseClass, sizeClass, hoverClass, clickable ? 'cursor-pointer' : 'cursor-default', 'gap-2', className].join(' ');
  };
  // Colours without an entry use the text colour
  const dotClasses: Record<string, string> = {
    pippink: 'bg-pippink-600',
    pipgreen: 'bg-pipgreen-600',
    pippurple: 'bg-pippurple-600',
  };
  const dotElement = hasDot
    ? <span aria-hidden="true" className={`size-1.5 shrink-0 self-center rounded-full ${dotClasses[colour] ?? 'bg-current'}`} />
    : null;
  if (closeButton && onClick) {
    return (
      <div className={getChipClasses(colour, onClick, small)}>
        {dotElement}
        <span title={text} className="truncate cursor-default">{text}</span>
        <button
          type="button"
          title={text}
          onClick={onClick}
          className="cursor-pointer"
        >
          {customIcons.closeIcon}
        </button>
      </div>

    );
  }
  if (onClick) {
    return (
      <button
        type="button"
        title={text}
        onClick={onClick}
        className={getChipClasses(colour, onClick, small)}
      >
        {dotElement}
        {text}
        {tooltip && <Tooltip label={`${text}-tooltip`} text={tooltip} />}
      </button>
    );
  }
  return (

    <div
      title={text}
      className={getChipClasses(colour, onClick, small)}
    >
      {dotElement}
      <p title={text} className={`${small ? 'truncate' : ''}`}>{text}</p>
      {tooltip && <Tooltip label={`${text}-tooltip`} text={tooltip} />}
    </div>
  );
}
